/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type { DataEnvelopeOfListOfCommunicationWhatsAppReceiptDto } from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const receiveEvolutionReceipt = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>({ url: `/v1/webhooks/evolution`, method: 'POST', signal }, options)
}

export const getReceiveEvolutionReceiptMutationKey = () => ['receiveEvolutionReceipt'] as const

export const getReceiveEvolutionReceiptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveEvolutionReceipt>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveEvolutionReceipt>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getReceiveEvolutionReceiptMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveEvolutionReceipt>>,
    void
  > = () => {
    return receiveEvolutionReceipt(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ReceiveEvolutionReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveEvolutionReceipt>>
>

export type ReceiveEvolutionReceiptMutationError = unknown

export const useReceiveEvolutionReceipt = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof receiveEvolutionReceipt>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof receiveEvolutionReceipt>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getReceiveEvolutionReceiptMutationOptions(options), queryClient)
}
export const getCommunicationWhatsAppReceipts = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfListOfCommunicationWhatsAppReceiptDto>(
    { url: `/v1/communications/${id}/whatsapp-receipts`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationWhatsAppReceiptsQueryKey = (id: string) => {
  return [`/v1/communications/${id}/whatsapp-receipts`] as const
}

export const getGetCommunicationWhatsAppReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationWhatsAppReceiptsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>> = ({
    signal,
  }) => getCommunicationWhatsAppReceipts(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommunicationWhatsAppReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>
>
export type GetCommunicationWhatsAppReceiptsQueryError = unknown

export function useGetCommunicationWhatsAppReceipts<
  TData = Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationWhatsAppReceipts<
  TData = Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationWhatsAppReceipts<
  TData = Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCommunicationWhatsAppReceipts<
  TData = Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationWhatsAppReceipts>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationWhatsAppReceiptsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
